export default __webpack_public_path__ + "static/media/automatskavrata1.fa548514.png";